module.exports = __webpack_public_path__ + "static/media/Youtube.028a6c9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/Youtube.svg
// module id = 333
// module chunks = 0